// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TX6l","top":"styles_top__3gdJr"};